import { IOrders } from '../../interfaces';

export const orders: IOrders[] = [
    {
        id: '511936057',
        id_dispositivo_asignado: '117115',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:20:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:25:00.000Z',
        codigo_pedido: '090623-48',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428889',
        codigo: 'Codigo Cliente 048',
        razon_social: 'Nombre cliente 048',
        domicilio: 'Juan Francisco Seguí 3500, C1425 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.579593',
        longitud: '-58.408005',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17006',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17006',
        detallescheck: '1',
        id_cliente_original: '162428889',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117115',
        tempChecked: false,
    },
    {
        id: '511936053',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:26:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:31:00.000Z',
        codigo_pedido: '090623-44',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428885',
        codigo: 'Codigo Cliente 044',
        razon_social: 'Nombre cliente 044',
        domicilio: 'Fray Justo Sta. María de Oro 2326, C1425FOH Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.580909',
        longitud: '-58.426121',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20006',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20006',
        detallescheck: '1',
        id_cliente_original: '162428885',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936034',
        id_dispositivo_asignado: '117115',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-23T02:26:00.000Z',
        horario_entrega_hasta: '2025-04-23T02:31:00.000Z',
        codigo_pedido: '090623-25',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428866',
        codigo: 'Codigo Cliente 025',
        razon_social: 'Nombre cliente 025',
        domicilio: 'Paraguay 1500, C1061ABB Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.598498',
        longitud: '-58.388068',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7503',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7503',
        detallescheck: '1',
        id_cliente_original: '162428866',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117115',
        tempChecked: false,
    },
    {
        id: '511936055',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:00:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:05:00.000Z',
        codigo_pedido: '090623-46',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428887',
        codigo: 'Codigo Cliente 046',
        razon_social: 'Nombre cliente 046',
        domicilio: 'Av. Álvarez Thomas 732, C1427CCU Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.580149',
        longitud: '-58.452853',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7506',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7506',
        detallescheck: '1',
        id_cliente_original: '162428887',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936051',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:12:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:17:00.000Z',
        codigo_pedido: '090623-42',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428883',
        codigo: 'Codigo Cliente 042',
        razon_social: 'Nombre cliente 042',
        domicilio: 'Av. Gral. Las Heras 4095, C1425 ATE, Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.581400',
        longitud: '-58.416619',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35005',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35005',
        detallescheck: '1',
        id_cliente_original: '162428883',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936093',
        id_dispositivo_asignado: '15777',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:00:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:05:00.000Z',
        codigo_pedido: '090623-84',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428925',
        codigo: 'Codigo Cliente 084',
        razon_social: 'Nombre cliente 084',
        domicilio:
            'Parana 746, Ciudad de buenos aires, Ciudad de buenos aires,Argentina Buenos aires Buenos aires , Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.60008',
        longitud: '-58.38817',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FF0F000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35011',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35011',
        detallescheck: '1',
        id_cliente_original: '162428925',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '15777',
        tempChecked: false,
    },
    {
        id: '511936028',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T18:30:00.000Z',
        horario_entrega_hasta: '2025-04-22T18:35:00.000Z',
        codigo_pedido: '090623-19',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428860',
        codigo: 'Codigo Cliente 019',
        razon_social: 'Nombre cliente 019',
        domicilio: 'Tte. Gral. Eustaquio Frías 225, C1414 DVE, Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.602970',
        longitud: '-58.435380',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4002',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4002',
        detallescheck: '1',
        id_cliente_original: '162428860',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936089',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:59:00.000Z',
        horario_entrega_hasta: '2025-04-22T20:04:00.000Z',
        codigo_pedido: '090623-80',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428921',
        codigo: 'Codigo Cliente 080',
        razon_social: 'Nombre cliente 080',
        domicilio: 'Lavalle 2516, C1052AAF Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.603463',
        longitud: '-58.402424',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60011',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60011',
        detallescheck: '1',
        id_cliente_original: '162428921',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936032',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:59:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:04:00.000Z',
        codigo_pedido: '090623-23',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428864',
        codigo: 'Codigo Cliente 023',
        razon_social: 'Nombre cliente 023',
        domicilio:
            'Parana 746, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.60008',
        longitud: '-58.38817',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FFFF000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20003',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20003',
        detallescheck: '1',
        id_cliente_original: '162428864',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936026',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:00:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:05:00.000Z',
        codigo_pedido: '090623-17',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428858',
        codigo: 'Codigo Cliente 017',
        razon_social: 'Nombre cliente 017',
        domicilio:
            'Av. Pres. Roque Sáenz Peña 720, C1084 Cdad. Autónoma de Buenos Aires, Ciudad Autónoma de Buenos Aires, Argentina',
        latitud: '-34.606486',
        longitud: '-58.376882',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60002',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60002',
        detallescheck: '1',
        id_cliente_original: '162428858',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936091',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T20:13:00.000Z',
        horario_entrega_hasta: '2025-04-22T20:18:00.000Z',
        codigo_pedido: '090623-82',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428923',
        codigo: 'Codigo Cliente 082',
        razon_social: 'Nombre cliente 082',
        domicilio: 'Lavalle 780, C1047 AAP, Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.60245',
        longitud: '-58.377785',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4011',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4011',
        detallescheck: '1',
        id_cliente_original: '162428923',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936013',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:38:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:43:00.000Z',
        codigo_pedido: '090623-4',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428845',
        codigo: 'Codigo Cliente 004',
        razon_social: 'Nombre cliente 004',
        domicilio:
            'Bravo Mario 258, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.60767',
        longitud: '-58.41743',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '0000000FFC00',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7500',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7500',
        detallescheck: '1',
        id_cliente_original: '162428845',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936068',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:16:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:21:00.000Z',
        codigo_pedido: '090623-59',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428900',
        codigo: 'Codigo Cliente 059',
        razon_social: 'Nombre cliente 059',
        domicilio: 'Av. Medrano 322, C1179 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.606955',
        longitud: '-58.421497',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60008',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60008',
        detallescheck: '1',
        id_cliente_original: '162428900',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936064',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:06:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:11:00.000Z',
        codigo_pedido: '090623-55',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428896',
        codigo: 'Codigo Cliente 055',
        razon_social: 'Nombre cliente 055',
        domicilio: 'Olleros 3215, Ciudad Autónoma de Buenos Aires, Argentina',
        latitud: '-34.578592',
        longitud: '-58.448806',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17007',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17007',
        detallescheck: '1',
        id_cliente_original: '162428896',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936087',
        id_dispositivo_asignado: '117115',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-23T02:08:00.000Z',
        horario_entrega_hasta: '2025-04-23T02:13:00.000Z',
        codigo_pedido: '090623-78',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428919',
        codigo: 'Codigo Cliente 078',
        razon_social: 'Nombre cliente 078',
        domicilio:
            'Av. Rivadavia 879, C1002 Cdad. Autónoma de Buenos Aires, Ciudad Autónoma de Buenos Aires, Argentina',
        latitud: '-34.608208',
        longitud: '-58.37893',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15011',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15011',
        detallescheck: '1',
        id_cliente_original: '162428919',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117115',
        tempChecked: false,
    },
    {
        id: '511936030',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:32:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:37:00.000Z',
        codigo_pedido: '090623-21',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428862',
        codigo: 'Codigo Cliente 021',
        razon_social: 'Nombre cliente 021',
        domicilio: 'Gascón 839, C1181ACO Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.601144',
        longitud: '-58.423459',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35002',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35002',
        detallescheck: '1',
        id_cliente_original: '162428862',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936066',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:00:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:05:00.000Z',
        codigo_pedido: '090623-57',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428898',
        codigo: 'Codigo Cliente 057',
        razon_social: 'Nombre cliente 057',
        domicilio: 'F. P. Insausti 753, Luján, Provincia de Buenos Aires, Argentina',
        latitud: '-34.578370',
        longitud: '-59.097983',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15008',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15008',
        detallescheck: '1',
        id_cliente_original: '162428898',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936048',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T14:34:00.000Z',
        horario_entrega_hasta: '2025-04-22T14:39:00.000Z',
        codigo_pedido: '090623-39',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428880',
        codigo: 'Codigo Cliente 039',
        razon_social: 'Nombre cliente 039',
        domicilio:
            'Helguera 4941, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.58581',
        longitud: '-58.50666',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FF0F000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7505',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7505',
        detallescheck: '1',
        id_cliente_original: '162428880',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936011',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:00:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:05:00.000Z',
        codigo_pedido: '090623-2',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428843',
        codigo: 'Codigo Cliente 002',
        razon_social: 'Nombre cliente 002',
        domicilio:
            'Bartolome Mitre 2179, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.60823',
        longitud: '-58.39737',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FFFF000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20000',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20000',
        detallescheck: '1',
        id_cliente_original: '162428843',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936083',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:06:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:11:00.000Z',
        codigo_pedido: '090623-74',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428915',
        codigo: 'Codigo Cliente 074',
        razon_social: 'Nombre cliente 074',
        domicilio: 'Esmeralda 340, Cdad. Autónoma de Buenos Aires, Ciudad Autónoma de Buenos Aires, Argentina',
        latitud: '-34.604275',
        longitud: '-58.378264',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7510',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7510',
        detallescheck: '1',
        id_cliente_original: '162428915',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936019',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T18:43:00.000Z',
        horario_entrega_hasta: '2025-04-22T18:48:00.000Z',
        codigo_pedido: '090623-10',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428851',
        codigo: 'Codigo Cliente 010',
        razon_social: 'Nombre cliente 010',
        domicilio: 'Av. Angel Gallardo 685, C1414 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.605704',
        longitud: '-58.440224',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60001',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60001',
        detallescheck: '1',
        id_cliente_original: '162428851',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936062',
        id_dispositivo_asignado: '117115',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-23T02:43:00.000Z',
        horario_entrega_hasta: '2025-04-23T02:48:00.000Z',
        codigo_pedido: '090623-53',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428894',
        codigo: 'Codigo Cliente 053',
        razon_social: 'Nombre cliente 053',
        domicilio: 'Av. Medrano 322, C1179 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.606955',
        longitud: '-58.421497',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7507',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7507',
        detallescheck: '1',
        id_cliente_original: '162428894',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117115',
        tempChecked: false,
    },
    {
        id: '511936085',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:17:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:22:00.000Z',
        codigo_pedido: '090623-76',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428917',
        codigo: 'Codigo Cliente 076',
        razon_social: 'Nombre cliente 076',
        domicilio: 'Moldes 500, C1426ALB Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.572799',
        longitud: '-58.446688',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17010',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17010',
        detallescheck: '1',
        id_cliente_original: '162428917',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936044',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T18:19:00.000Z',
        horario_entrega_hasta: '2025-04-22T18:24:00.000Z',
        codigo_pedido: '090623-35',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428876',
        codigo: 'Codigo Cliente 035',
        razon_social: 'Nombre cliente 035',
        domicilio:
            'Paraguay 3763, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.59062',
        longitud: '-58.41652',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FFFF000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35004',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35004',
        detallescheck: '1',
        id_cliente_original: '162428876',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936107',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:59:00.000Z',
        horario_entrega_hasta: '2025-04-22T20:04:00.000Z',
        codigo_pedido: '090623-98',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428939',
        codigo: 'Codigo Cliente 098',
        razon_social: 'Nombre cliente 098',
        domicilio:
            'Av. Rivadavia 975, B1852 Cdad. Autónoma de Buenos Aires, Ciudad Autónoma de Buenos Aires, Argentina',
        latitud: '-34.608237',
        longitud: '-58.380231',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35013',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35013',
        detallescheck: '1',
        id_cliente_original: '162428939',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936079',
        id_dispositivo_asignado: '15777',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:15:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:20:00.000Z',
        codigo_pedido: '090623-70',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428911',
        codigo: 'Codigo Cliente 070',
        razon_social: 'Nombre cliente 070',
        domicilio: 'Cnel. Apolinario Figueroa 539, C1416DPA Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.605591',
        longitud: '-58.447692',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35009',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35009',
        detallescheck: '1',
        id_cliente_original: '162428911',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '15777',
        tempChecked: false,
    },
    {
        id: '511936023',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:15:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:20:00.000Z',
        codigo_pedido: '090623-14',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428855',
        codigo: 'Codigo Cliente 014',
        razon_social: 'Nombre cliente 014',
        domicilio:
            'Suipacha 362, ciudad de buenos aires, ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.60415',
        longitud: '-58.37947',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FFFF000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35001',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35001',
        detallescheck: '1',
        id_cliente_original: '162428855',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936046',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T18:54:00.000Z',
        horario_entrega_hasta: '2025-04-22T18:59:00.000Z',
        codigo_pedido: '090623-37',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428878',
        codigo: 'Codigo Cliente 037',
        razon_social: 'Nombre cliente 037',
        domicilio:
            'Newbery Jorge 3972, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.58768',
        longitud: '-58.45036',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '0000000FFC00',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20005',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20005',
        detallescheck: '1',
        id_cliente_original: '162428878',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936081',
        id_dispositivo_asignado: '117115',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-23T02:15:00.000Z',
        horario_entrega_hasta: '2025-04-23T02:20:00.000Z',
        codigo_pedido: '090623-72',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428913',
        codigo: 'Codigo Cliente 072',
        razon_social: 'Nombre cliente 072',
        domicilio:
            'Suipacha 362, ciudad de buenos aires, ciudad de buenos aires,Argentina Buenos aires Buenos aires , Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.60415',
        longitud: '-58.37947',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '0000000FFC00',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20010',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20010',
        detallescheck: '1',
        id_cliente_original: '162428913',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117115',
        tempChecked: false,
    },
    {
        id: '511936038',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:48:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:53:00.000Z',
        codigo_pedido: '090623-29',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428870',
        codigo: 'Codigo Cliente 029',
        razon_social: 'Nombre cliente 029',
        domicilio:
            'Gorriti 4015, ciudad de buenos aires, ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.5953',
        longitud: '-58.4216',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FFFF000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15004',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15004',
        detallescheck: '1',
        id_cliente_original: '162428870',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936103',
        id_dispositivo_asignado: '117112',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:33:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:38:00.000Z',
        codigo_pedido: '090623-94',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428935',
        codigo: 'Codigo Cliente 094',
        razon_social: 'Nombre cliente 094',
        domicilio:
            'Thames 653, Ciudad de buenos aires, Ciudad de buenos aires,Argentina Buenos aires Buenos aires , Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.59432',
        longitud: '-58.44134',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FF0F000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60013',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60013',
        detallescheck: '1',
        id_cliente_original: '162428935',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117112',
        tempChecked: false,
    },
    {
        id: '511936077',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T20:29:00.000Z',
        horario_entrega_hasta: '2025-04-22T20:34:00.000Z',
        codigo_pedido: '090623-68',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428909',
        codigo: 'Codigo Cliente 068',
        razon_social: 'Nombre cliente 068',
        domicilio: 'Doctor Mariano Moreno 978, La Lucila, Provincia de Buenos Aires, Argentina',
        latitud: '-34.497104',
        longitud: '-58.492945',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4009',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4009',
        detallescheck: '1',
        id_cliente_original: '162428909',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936017',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:27:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:32:00.000Z',
        codigo_pedido: '090623-8',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428849',
        codigo: 'Codigo Cliente 008',
        razon_social: 'Nombre cliente 008',
        domicilio: 'Av. Medrano 322, C1179 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.606955',
        longitud: '-58.421497',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15001',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15001',
        detallescheck: '1',
        id_cliente_original: '162428849',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936099',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:34:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:39:00.000Z',
        codigo_pedido: '090623-90',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428931',
        codigo: 'Codigo Cliente 090',
        razon_social: 'Nombre cliente 090',
        domicilio:
            'Cuenca 3749, Ciudad de buenos aires, Ciudad de buenos aires,Argentina Buenos aires Buenos aires , Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.59548',
        longitud: '-58.49995',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FFFF000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17012',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17012',
        detallescheck: '1',
        id_cliente_original: '162428931',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936060',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:06:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:11:00.000Z',
        codigo_pedido: '090623-51',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428892',
        codigo: 'Codigo Cliente 051',
        razon_social: 'Nombre cliente 051',
        domicilio: 'Av. Sta. Fe 4550, C1425 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.579263',
        longitud: '-58.425138',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20007',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20007',
        detallescheck: '1',
        id_cliente_original: '162428892',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936042',
        id_dispositivo_asignado: '117112',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:38:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:43:00.000Z',
        codigo_pedido: '090623-33',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428874',
        codigo: 'Codigo Cliente 033',
        razon_social: 'Nombre cliente 033',
        domicilio:
            'Thames 653, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.59432',
        longitud: '-58.44134',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FF0F000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4004',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4004',
        detallescheck: '1',
        id_cliente_original: '162428874',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117112',
        tempChecked: false,
    },
    {
        id: '511936105',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:55:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:00:00.000Z',
        codigo_pedido: '090623-96',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428937',
        codigo: 'Codigo Cliente 096',
        razon_social: 'Nombre cliente 096',
        domicilio: 'Costa Rica 4187, C1176ADE Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.591479',
        longitud: '-58.421901',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4013',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4013',
        detallescheck: '1',
        id_cliente_original: '162428937',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936101',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T18:30:00.000Z',
        horario_entrega_hasta: '2025-04-22T18:35:00.000Z',
        codigo_pedido: '090623-92',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428933',
        codigo: 'Codigo Cliente 092',
        razon_social: 'Nombre cliente 092',
        domicilio: 'Honduras 4170, C1180ACJ Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.594463',
        longitud: '-58.422195',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15013',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15013',
        detallescheck: '1',
        id_cliente_original: '162428933',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936073',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:22:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:27:00.000Z',
        codigo_pedido: '090623-64',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428905',
        codigo: 'Codigo Cliente 064',
        razon_social: 'Nombre cliente 064',
        domicilio: 'Seijo 654, Luján, Provincia de Buenos Aires, Argentina',
        latitud: '-34.576898',
        longitud: '-59.100051',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15009',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15009',
        detallescheck: '1',
        id_cliente_original: '162428905',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936021',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:48:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:53:00.000Z',
        codigo_pedido: '090623-12',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428853',
        codigo: 'Codigo Cliente 012',
        razon_social: 'Nombre cliente 012',
        domicilio: 'Av. Patricias Argentinas 330, C1405 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.604642',
        longitud: '-58.434739',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4001',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4001',
        detallescheck: '1',
        id_cliente_original: '162428853',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936036',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:38:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:43:00.000Z',
        codigo_pedido: '090623-27',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428868',
        codigo: 'Codigo Cliente 027',
        razon_social: 'Nombre cliente 027',
        domicilio: 'Gascón 1131, C1181ACU Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.597298',
        longitud: '-58.423223',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17003',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17003',
        detallescheck: '1',
        id_cliente_original: '162428868',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936075',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T20:05:00.000Z',
        horario_entrega_hasta: '2025-04-22T20:10:00.000Z',
        codigo_pedido: '090623-66',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428907',
        codigo: 'Codigo Cliente 066',
        razon_social: 'Nombre cliente 066',
        domicilio: 'Av. Rivadavia 1200, C1085 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.608601',
        longitud: '-58.383329',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60009',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60009',
        detallescheck: '1',
        id_cliente_original: '162428907',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936015',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:21:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:26:00.000Z',
        codigo_pedido: '090623-6',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428847',
        codigo: 'Codigo Cliente 006',
        razon_social: 'Nombre cliente 006',
        domicilio: 'Av. Medrano 322, C1179 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.606955',
        longitud: '-58.421497',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17000',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17000',
        detallescheck: '1',
        id_cliente_original: '162428847',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936097',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:50:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:55:00.000Z',
        codigo_pedido: '090623-88',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428929',
        codigo: 'Codigo Cliente 088',
        razon_social: 'Nombre cliente 088',
        domicilio: 'Av. Córdoba 3560, C1188AAO Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.597946',
        longitud: '-58.416737',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7512',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7512',
        detallescheck: '1',
        id_cliente_original: '162428929',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936040',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T18:25:00.000Z',
        horario_entrega_hasta: '2025-04-22T18:30:00.000Z',
        codigo_pedido: '090623-31',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428872',
        codigo: 'Codigo Cliente 031',
        razon_social: 'Nombre cliente 031',
        domicilio: 'Honduras 4170, C1180ACJ Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.594463',
        longitud: '-58.422195',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60004',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60004',
        detallescheck: '1',
        id_cliente_original: '162428872',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936071',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:57:00.000Z',
        horario_entrega_hasta: '2025-04-22T18:02:00.000Z',
        codigo_pedido: '090623-62',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428903',
        codigo: 'Codigo Cliente 062',
        razon_social: 'Nombre cliente 062',
        domicilio: 'Juan Francisco Seguí 3900, C1425 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.577884',
        longitud: '-58.412475',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17008',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17008',
        detallescheck: '1',
        id_cliente_original: '162428903',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936095',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-23T00:56:00.000Z',
        horario_entrega_hasta: '2025-04-23T01:01:00.000Z',
        codigo_pedido: '090623-86',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428927',
        codigo: 'Codigo Cliente 086',
        razon_social: 'Nombre cliente 086',
        domicilio: 'Paraguay 1500, C1061ABB Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.598498',
        longitud: '-58.388068',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20012',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20012',
        detallescheck: '1',
        id_cliente_original: '162428927',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936058',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:21:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:26:00.000Z',
        codigo_pedido: '090623-49',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428890',
        codigo: 'Codigo Cliente 049',
        razon_social: 'Nombre cliente 049',
        domicilio: 'Av. Sta. Fe 4500, C1425 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.579507',
        longitud: '-58.424471',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35006',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35006',
        detallescheck: '1',
        id_cliente_original: '162428890',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936054',
        id_dispositivo_asignado: '5903',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:36:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:41:00.000Z',
        codigo_pedido: '090623-45',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428886',
        codigo: 'Codigo Cliente 045',
        razon_social: 'Nombre cliente 045',
        domicilio: 'C592+R8 Francisco Alvarez, Provincia de Buenos Aires, Argentina',
        latitud: '-34.580437',
        longitud: '-58.849187',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60006',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60006',
        detallescheck: '1',
        id_cliente_original: '162428886',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '5903',
        tempChecked: false,
    },
    {
        id: '511936056',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:48:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:53:00.000Z',
        codigo_pedido: '090623-47',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428888',
        codigo: 'Codigo Cliente 047',
        razon_social: 'Nombre cliente 047',
        domicilio: 'Av. Sarmiento 2704, C1425 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.579780',
        longitud: '-58.420932',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4006',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4006',
        detallescheck: '1',
        id_cliente_original: '162428888',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936029',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T20:21:00.000Z',
        horario_entrega_hasta: '2025-04-22T20:26:00.000Z',
        codigo_pedido: '090623-20',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428861',
        codigo: 'Codigo Cliente 020',
        razon_social: 'Nombre cliente 020',
        domicilio:
            'Reconquista 545, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.60149',
        longitud: '-58.37252',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FFFF000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17002',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17002',
        detallescheck: '1',
        id_cliente_original: '162428861',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936052',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:02:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:07:00.000Z',
        codigo_pedido: '090623-43',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428884',
        codigo: 'Codigo Cliente 043',
        razon_social: 'Nombre cliente 043',
        domicilio:
            'Charlone 861, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.58146',
        longitud: '-58.4555',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '0000000FFC00',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15006',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15006',
        detallescheck: '1',
        id_cliente_original: '162428884',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936094',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:08:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:13:00.000Z',
        codigo_pedido: '090623-85',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428926',
        codigo: 'Codigo Cliente 085',
        razon_social: 'Nombre cliente 085',
        domicilio:
            'Av Cordoba 2440, Ciudad de buenos aires, Ciudad de buenos aires,Argentina Buenos aires Buenos aires , Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.59949',
        longitud: '-58.40171',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '0000000FFC00',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15012',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15012',
        detallescheck: '1',
        id_cliente_original: '162428926',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936033',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:00:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:05:00.000Z',
        codigo_pedido: '090623-24',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428865',
        codigo: 'Codigo Cliente 024',
        razon_social: 'Nombre cliente 024',
        domicilio:
            'Av Cordoba 2440, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.59949',
        longitud: '-58.40171',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FF0F000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60003',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60003',
        detallescheck: '1',
        id_cliente_original: '162428865',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936069',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:26:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:31:00.000Z',
        codigo_pedido: '090623-60',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428901',
        codigo: 'Codigo Cliente 060',
        razon_social: 'Nombre cliente 060',
        domicilio: 'Av. Medrano 322, C1179 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.606955',
        longitud: '-58.421497',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7508',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7508',
        detallescheck: '1',
        id_cliente_original: '162428901',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936027',
        id_dispositivo_asignado: '117112',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:12:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:17:00.000Z',
        codigo_pedido: '090623-18',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428859',
        codigo: 'Codigo Cliente 018',
        razon_social: 'Nombre cliente 018',
        domicilio: 'Lavalle 2516, C1052AAF Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.603463',
        longitud: '-58.402424',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7502',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7502',
        detallescheck: '1',
        id_cliente_original: '162428859',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117112',
        tempChecked: false,
    },
    {
        id: '511936050',
        id_dispositivo_asignado: '15777',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:29:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:34:00.000Z',
        codigo_pedido: '090623-41',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428882',
        codigo: 'Codigo Cliente 041',
        razon_social: 'Nombre cliente 041',
        domicilio: 'Comuna 15, La Pampa 5848, C1431CRB Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.584161',
        longitud: '-58.487483',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17005',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17005',
        detallescheck: '1',
        id_cliente_original: '162428882',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '15777',
        tempChecked: false,
    },
    {
        id: '511936092',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:48:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:53:00.000Z',
        codigo_pedido: '090623-83',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428924',
        codigo: 'Codigo Cliente 083',
        razon_social: 'Nombre cliente 083',
        domicilio: 'Tucumán 573, San Nicolas, Ciudad Autónoma de Buenos Aires, Argentina',
        latitud: '-34.600967',
        longitud: '-58.374929',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17011',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17011',
        detallescheck: '1',
        id_cliente_original: '162428924',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936014',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:07:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:12:00.000Z',
        codigo_pedido: '090623-5',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428846',
        codigo: 'Codigo Cliente 005',
        razon_social: 'Nombre cliente 005',
        domicilio:
            'Teniente General Juan Domingo Peron 2687, Buenos Aires, Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.60756',
        longitud: '-58.40446',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FFFF000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4000',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4000',
        detallescheck: '1',
        id_cliente_original: '162428846',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936031',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T22:37:00.000Z',
        horario_entrega_hasta: '2025-04-22T22:42:00.000Z',
        codigo_pedido: '090623-22',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428863',
        codigo: 'Codigo Cliente 022',
        razon_social: 'Nombre cliente 022',
        domicilio: 'Tucuman 573, San Nicolas, Buenos Aires, Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-33.35841',
        longitud: '-60.22211',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '0000000FFC00',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15003',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15003',
        detallescheck: '1',
        id_cliente_original: '162428863',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936088',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:51:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:56:00.000Z',
        codigo_pedido: '090623-79',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428920',
        codigo: 'Codigo Cliente 079',
        razon_social: 'Nombre cliente 079',
        domicilio: 'Av. Corrientes 679, San Nicolás, C1043 San Nicolas, Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.603254',
        longitud: '-58.376377',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20011',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20011',
        detallescheck: '1',
        id_cliente_original: '162428920',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936084',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:34:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:39:00.000Z',
        codigo_pedido: '090623-75',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428916',
        codigo: 'Codigo Cliente 075',
        razon_social: 'Nombre cliente 075',
        domicilio: 'Sinclair 3158, Buenos Aires, Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.57354',
        longitud: '-58.42274',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '0000000FFC00',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4010',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4010',
        detallescheck: '1',
        id_cliente_original: '162428916',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936067',
        id_dispositivo_asignado: '15777',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:09:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:14:00.000Z',
        codigo_pedido: '090623-58',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428899',
        codigo: 'Codigo Cliente 058',
        razon_social: 'Nombre cliente 058',
        domicilio: 'Av. Álvarez Thomas 2175, C1430EEB Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.577940',
        longitud: '-58.471790',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20008',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20008',
        detallescheck: '1',
        id_cliente_original: '162428899',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '15777',
        tempChecked: false,
    },
    {
        id: '511936025',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:19:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:24:00.000Z',
        codigo_pedido: '090623-16',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428857',
        codigo: 'Codigo Cliente 016',
        razon_social: 'Nombre cliente 016',
        domicilio: 'Sarmiento 4568, C1197AAR Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.604118',
        longitud: '-58.429860',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20002',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20002',
        detallescheck: '1',
        id_cliente_original: '162428857',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936090',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:13:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:18:00.000Z',
        codigo_pedido: '090623-81',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428922',
        codigo: 'Codigo Cliente 081',
        razon_social: 'Nombre cliente 081',
        domicilio: 'Tte. Gral. Eustaquio Frías 225, C1414 DVE, Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.602970',
        longitud: '-58.435380',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7511',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7511',
        detallescheck: '1',
        id_cliente_original: '162428922',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936049',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T18:05:00.000Z',
        horario_entrega_hasta: '2025-04-22T18:10:00.000Z',
        codigo_pedido: '090623-40',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428881',
        codigo: 'Codigo Cliente 040',
        razon_social: 'Nombre cliente 040',
        domicilio:
            'Arenales 3836, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.5843',
        longitud: '-58.41546',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '0000000FFC00',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4005',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4005',
        detallescheck: '1',
        id_cliente_original: '162428881',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936012',
        id_dispositivo_asignado: '117112',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:00:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:05:00.000Z',
        codigo_pedido: '090623-3',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428844',
        codigo: 'Codigo Cliente 003',
        razon_social: 'Nombre cliente 003',
        domicilio: 'Rivadavia 413, Buenos Aires, Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.60784',
        longitud: '-58.37248',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FF0F000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60000',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60000',
        detallescheck: '1',
        id_cliente_original: '162428844',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117112',
        tempChecked: false,
    },
    {
        id: '511936086',
        id_dispositivo_asignado: '15777',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:10:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:15:00.000Z',
        codigo_pedido: '090623-77',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428918',
        codigo: 'Codigo Cliente 077',
        razon_social: 'Nombre cliente 077',
        domicilio: 'Av. Congreso 5399, C1431AAI Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.571410',
        longitud: '-58.493560',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35010',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35010',
        detallescheck: '1',
        id_cliente_original: '162428918',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '15777',
        tempChecked: false,
    },
    {
        id: '511936063',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:31:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:36:00.000Z',
        codigo_pedido: '090623-54',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428895',
        codigo: 'Codigo Cliente 054',
        razon_social: 'Nombre cliente 054',
        domicilio: 'Olleros 3215, C1426CSK Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.578592',
        longitud: '-58.448806',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4007',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4007',
        detallescheck: '1',
        id_cliente_original: '162428895',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936010',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:00:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:05:00.000Z',
        codigo_pedido: '090623-1',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428842',
        codigo: 'Codigo Cliente 001',
        razon_social: 'Nombre cliente 001',
        domicilio: 'Caseros 518, B1748 Gral. Rodríguez, Provincia de Buenos Aires, Argentina',
        latitud: '-34.608036',
        longitud: '-58.932092',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15000',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: '0.00',
        cobros: '15000',
        detallescheck: '1',
        id_cliente_original: '162428842',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936082',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T14:20:00.000Z',
        horario_entrega_hasta: '2025-04-22T14:25:00.000Z',
        codigo_pedido: '090623-73',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428914',
        codigo: 'Codigo Cliente 073',
        razon_social: 'Nombre cliente 073',
        domicilio: 'Av. Dr. Ricardo Balbín 4326, C1430ABO Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.555310',
        longitud: '-58.492761',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60010',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60010',
        detallescheck: '1',
        id_cliente_original: '162428914',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936039',
        id_dispositivo_asignado: '117112',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:21:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:26:00.000Z',
        codigo_pedido: '090623-30',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428871',
        codigo: 'Codigo Cliente 030',
        razon_social: 'Nombre cliente 030',
        domicilio: 'Gral. Lucio Norberto Mansilla 2934, C1425 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.594904',
        longitud: '-58.408309',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20004',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20004',
        detallescheck: '1',
        id_cliente_original: '162428871',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117112',
        tempChecked: false,
    },
    {
        id: '511936104',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:19:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:24:00.000Z',
        codigo_pedido: '090623-95',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428936',
        codigo: 'Codigo Cliente 095',
        razon_social: 'Nombre cliente 095',
        domicilio: 'Av. Nazca 3968, C1419DFP Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.591819',
        longitud: '-58.497505',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7513',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7513',
        detallescheck: '1',
        id_cliente_original: '162428936',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936065',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:26:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:31:00.000Z',
        codigo_pedido: '090623-56',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428897',
        codigo: 'Codigo Cliente 056',
        razon_social: 'Nombre cliente 056',
        domicilio: 'Olleros 3215, C1426CSK Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.578592',
        longitud: '-58.448806',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35007',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35007',
        detallescheck: '1',
        id_cliente_original: '162428897',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936024',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:41:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:46:00.000Z',
        codigo_pedido: '090623-15',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428856',
        codigo: 'Codigo Cliente 015',
        razon_social: 'Nombre cliente 015',
        domicilio: 'Sarmiento 4568, C1197AAR Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.604118',
        longitud: '-58.429860',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15002',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15002',
        detallescheck: '1',
        id_cliente_original: '162428856',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936047',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T18:12:00.000Z',
        horario_entrega_hasta: '2025-04-22T18:17:00.000Z',
        codigo_pedido: '090623-38',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428879',
        codigo: 'Codigo Cliente 038',
        razon_social: 'Nombre cliente 038',
        domicilio: 'Armenia 2155, C1425FBC Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.586657',
        longitud: '-58.422603',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60005',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60005',
        detallescheck: '1',
        id_cliente_original: '162428879',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936043',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T18:36:00.000Z',
        horario_entrega_hasta: '2025-04-22T18:41:00.000Z',
        codigo_pedido: '090623-34',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428875',
        codigo: 'Codigo Cliente 034',
        razon_social: 'Nombre cliente 034',
        domicilio: 'Costa Rica 4187, C1176ADE Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.591479',
        longitud: '-58.421901',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17004',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17004',
        detallescheck: '1',
        id_cliente_original: '162428875',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936106',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:31:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:36:00.000Z',
        codigo_pedido: '090623-97',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428938',
        codigo: 'Codigo Cliente 097',
        razon_social: 'Nombre cliente 097',
        domicilio: 'Ecuador 1800, C1425EUL Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.591117',
        longitud: '-58.402692',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17013',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17013',
        detallescheck: '1',
        id_cliente_original: '162428938',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936078',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T18:36:00.000Z',
        horario_entrega_hasta: '2025-04-22T18:41:00.000Z',
        codigo_pedido: '090623-69',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428910',
        codigo: 'Codigo Cliente 069',
        razon_social: 'Nombre cliente 069',
        domicilio: 'Av. Patricias Argentinas 330, C1405 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.604642',
        longitud: '-58.434739',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17009',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17009',
        detallescheck: '1',
        id_cliente_original: '162428910',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936018',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:33:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:38:00.000Z',
        codigo_pedido: '090623-9',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428850',
        codigo: 'Codigo Cliente 009',
        razon_social: 'Nombre cliente 009',
        domicilio: 'Tte. Gral. Juan Domingo Perón 4445, C1199ABG Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.605846',
        longitud: '-58.429767',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20001',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20001',
        detallescheck: '1',
        id_cliente_original: '162428850',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936061',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:16:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:21:00.000Z',
        codigo_pedido: '090623-52',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428893',
        codigo: 'Codigo Cliente 052',
        razon_social: 'Nombre cliente 052',
        domicilio: 'Av. Sta. Fe 4550, C1425 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.579263',
        longitud: '-58.425138',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60007',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60007',
        detallescheck: '1',
        id_cliente_original: '162428893',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936045',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:00:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:05:00.000Z',
        codigo_pedido: '090623-36',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428877',
        codigo: 'Codigo Cliente 036',
        razon_social: 'Nombre cliente 036',
        domicilio: 'Charcas 3559, C1425 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.589403',
        longitud: '-58.414883',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15005',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15005',
        detallescheck: '1',
        id_cliente_original: '162428877',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936080',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:15:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:20:00.000Z',
        codigo_pedido: '090623-71',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428912',
        codigo: 'Codigo Cliente 071',
        razon_social: 'Nombre cliente 071',
        domicilio: 'Sinclair 3158, C1425 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.573505',
        longitud: '-58.422788',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FF0F000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15010',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15010',
        detallescheck: '1',
        id_cliente_original: '162428912',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936037',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:00:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:05:00.000Z',
        codigo_pedido: '090623-28',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428869',
        codigo: 'Codigo Cliente 028',
        razon_social: 'Nombre cliente 028',
        domicilio:
            'Cuenca 3749, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.59548',
        longitud: '-58.49995',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '0000000FFC00',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35003',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35003',
        detallescheck: '1',
        id_cliente_original: '162428869',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936102',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:59:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:04:00.000Z',
        codigo_pedido: '090623-93',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428934',
        codigo: 'Codigo Cliente 093',
        razon_social: 'Nombre cliente 093',
        domicilio:
            'Darwin 548, Ciudad de buenos aires, Ciudad de buenos aires,Argentina Buenos aires Buenos aires , Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.59447',
        longitud: '-58.44575',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FFFF000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20013',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20013',
        detallescheck: '1',
        id_cliente_original: '162428934',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936074',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:41:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:46:00.000Z',
        codigo_pedido: '090623-65',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428906',
        codigo: 'Codigo Cliente 065',
        razon_social: 'Nombre cliente 065',
        domicilio: 'Av. Colombia 3500, C1425 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.574252',
        longitud: '-58.418378',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '20009',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '20009',
        detallescheck: '1',
        id_cliente_original: '162428906',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936022',
        id_dispositivo_asignado: '15777',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:21:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:26:00.000Z',
        codigo_pedido: '090623-13',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428854',
        codigo: 'Codigo Cliente 013',
        razon_social: 'Nombre cliente 013',
        domicilio: 'Comuna 11, Manuel Ricardo Trelles 2082, C1416BRT Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.604302',
        longitud: '-58.466047',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '17001',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '17001',
        detallescheck: '1',
        id_cliente_original: '162428854',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '15777',
        tempChecked: false,
    },
    {
        id: '511936041',
        id_dispositivo_asignado: '116066',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:04:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:09:00.000Z',
        codigo_pedido: '090623-32',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428873',
        codigo: 'Codigo Cliente 032',
        razon_social: 'Nombre cliente 032',
        domicilio:
            'Darwin 548, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.59447',
        longitud: '-58.44575',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FFFF000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7504',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7504',
        detallescheck: '1',
        id_cliente_original: '162428873',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '116066',
        tempChecked: false,
    },
    {
        id: '511936076',
        id_dispositivo_asignado: '15777',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:51:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:56:00.000Z',
        codigo_pedido: '090623-67',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428908',
        codigo: 'Codigo Cliente 067',
        razon_social: 'Nombre cliente 067',
        domicilio: 'Doctor Mariano Moreno 978, La Lucila, Provincia de Buenos Aires, Argentina',
        latitud: '-34.497104',
        longitud: '-58.492945',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7509',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7509',
        detallescheck: '1',
        id_cliente_original: '162428908',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '15777',
        tempChecked: false,
    },
    {
        id: '511936016',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T19:32:00.000Z',
        horario_entrega_hasta: '2025-04-22T19:37:00.000Z',
        codigo_pedido: '090623-7',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428848',
        codigo: 'Codigo Cliente 007',
        razon_social: 'Nombre cliente 007',
        domicilio: 'Av. Medrano 322, C1179 Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.606955',
        longitud: '-58.421497',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '100',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.1',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35000',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35000',
        detallescheck: '1',
        id_cliente_original: '162428848',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936098',
        id_dispositivo_asignado: '117115',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-23T02:36:00.000Z',
        horario_entrega_hasta: '2025-04-23T02:41:00.000Z',
        codigo_pedido: '090623-89',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428930',
        codigo: 'Codigo Cliente 089',
        razon_social: 'Nombre cliente 089',
        domicilio: 'Av. Córdoba 3560, C1188AAO Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.597946',
        longitud: '-58.416737',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '0000000FFC00',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4012',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4012',
        detallescheck: '1',
        id_cliente_original: '162428930',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117115',
        tempChecked: false,
    },
    {
        id: '511936035',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:45:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:50:00.000Z',
        codigo_pedido: '090623-26',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428867',
        codigo: 'Codigo Cliente 026',
        razon_social: 'Nombre cliente 026',
        domicilio: 'Av. Córdoba 3560, C1188AAO Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.597946',
        longitud: '-58.416737',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4003',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4003',
        detallescheck: '1',
        id_cliente_original: '162428867',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936100',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T12:43:00.000Z',
        horario_entrega_hasta: '2025-04-22T12:48:00.000Z',
        codigo_pedido: '090623-91',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428932',
        codigo: 'Codigo Cliente 091',
        razon_social: 'Nombre cliente 091',
        domicilio:
            'Gorriti 4015, ciudad de buenos aires, ciudad de buenos aires,Argentina Buenos aires Buenos aires , Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.5953',
        longitud: '-58.4216',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FF0F000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35012',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35012',
        detallescheck: '1',
        id_cliente_original: '162428932',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936072',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T20:29:00.000Z',
        horario_entrega_hasta: '2025-04-22T20:34:00.000Z',
        codigo_pedido: '090623-63',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428904',
        codigo: 'Codigo Cliente 063',
        razon_social: 'Nombre cliente 063',
        domicilio: '239 Alem Leandro N. Av., Buenos Aires, Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.60491',
        longitud: '-58.36973',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FF0F000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FF0F000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '1570',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.02',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '35008',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '35008',
        detallescheck: '1',
        id_cliente_original: '162428904',
        ungroup: 0,
        demora: '5',
        tw_object: [
            ['09:00', '14:00'],
            ['16:00', '18:00'],
        ],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936020',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T14:01:00.000Z',
        horario_entrega_hasta: '2025-04-22T14:06:00.000Z',
        codigo_pedido: '090623-11',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428852',
        codigo: 'Codigo Cliente 011',
        razon_social: 'Nombre cliente 011',
        domicilio: 'Av. S. Martín 1903, C1416CRH Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.605229',
        longitud: '-58.455085',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 2',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '7501',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '7501',
        detallescheck: '1',
        id_cliente_original: '162428852',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936096',
        id_dispositivo_asignado: '117106',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T13:40:00.000Z',
        horario_entrega_hasta: '2025-04-22T13:45:00.000Z',
        codigo_pedido: '090623-87',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428928',
        codigo: 'Codigo Cliente 087',
        razon_social: 'Nombre cliente 087',
        domicilio: 'Av. Córdoba 3560, C1188AAO Cdad. Autónoma de Buenos Aires, Argentina',
        latitud: '-34.597946',
        longitud: '-58.416737',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: '',
        time_window: '00003FFFF000',
        dia_visita: '',
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '60012',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '60012',
        detallescheck: '1',
        id_cliente_original: '162428928',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117106',
        tempChecked: false,
    },
    {
        id: '511936059',
        id_dispositivo_asignado: '117096',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T14:09:00.000Z',
        horario_entrega_hasta: '2025-04-22T14:14:00.000Z',
        codigo_pedido: '090623-50',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428891',
        codigo: 'Codigo Cliente 050',
        razon_social: 'Nombre cliente 050',
        domicilio:
            'Flaubert 950, Bella Vista, Provincia de Buenos Aires, Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.57688',
        longitud: '-58.70148',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '00003FFFF000',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '00003FFFF000',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '25',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.05',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '15007',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '15007',
        detallescheck: '1',
        id_cliente_original: '162428891',
        ungroup: 0,
        demora: '5',
        tw_object: [['09:00', '18:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '117096',
        tempChecked: false,
    },
    {
        id: '511936070',
        id_dispositivo_asignado: '15777',
        fecha_asignacion: null,
        fecha_pedido: '2025-04-22',
        fecha_entrega_desde: null,
        fecha_entrega_hasta: null,
        horario_entrega_desde: '2025-04-22T17:00:00.000Z',
        horario_entrega_hasta: '2025-04-22T17:05:00.000Z',
        codigo_pedido: '090623-61',
        priority: '0',
        operacion: '1',
        orden: null,
        id_cliente: '162428902',
        codigo: 'Codigo Cliente 061',
        razon_social: 'Nombre cliente 061',
        domicilio:
            'Juramento 5046, Ciudad de buenos aires, Ciudad de buenos aires,Argentina ,Argentina,Buenos Aires,Buenos aires, Argentina',
        latitud: '-34.5779',
        longitud: '-58.482',
        codigo_tipo_cliente: 'SIN_TIPO',
        observaciones: null,
        time_window: '0000000FFC00',
        dia_visita: null,
        estado_cliente: '1',
        id_dispositivo_cliente: null,
        url_icon: 'clientes/sin_tipo.png',
        tipo_cliente: 'Sin tipificar',
        agrupacion: 'Agrupador 3',
        agrupacion_2: null,
        agrupacion_3: '0000000FFC00',
        comentarios: 'Observaciones',
        reintentos: 0,
        cortes: [
            {
                id_corte: '2',
                nombre: 'Peso',
                valor: '5',
                sufijo: 'kg',
                prefijo: '',
            },
            {
                id_corte: '3',
                nombre: 'Volumen',
                valor: '0.01',
                sufijo: 'm3',
                prefijo: '',
            },
            {
                id_corte: '7',
                nombre: 'Dinero',
                valor: '4008',
                sufijo: '$',
                prefijo: '$',
            },
        ],
        parametros: {
            ORIGEN: 'orders-templates',
            UNGROUP: '0',
        },
        peso_pedido: null,
        cobros: '4008',
        detallescheck: '1',
        id_cliente_original: '162428902',
        ungroup: 0,
        demora: '5',
        tw_object: [['14:00', '19:00']],
        editar: true,
        status: 'pending',
        tempAssigned: true,
        tempDeviceId: '15777',
        tempChecked: false,
    },
];
